import { EDITOR_TYPES } from '@pendo/services/Constants';
import sharedServices from '@pendo/services/package.json';

export function sanitizePollQuestion (pollQuestion) {
    const deletionRegex = /({required\/}|{branching\/})/g;
    pollQuestion = pollQuestion.replace(deletionRegex, '');

    const substitutionRegex = /\{(?:\s?)([^.\s]?visitor|account|parentAccount)\.([^|\s/]*)(?:\s?\|\s?([^}]+|[\\/s]+))?(?:\s?\/\s?){1}\}/g;
    const subRegex = new RegExp(substitutionRegex);
    let match;
    // eslint-disable-next-line no-cond-assign
    while ((match = pollQuestion.match(subRegex))) {
        const matches = subRegex.exec(match[0]);
        if (matches[2] === '') {
            pollQuestion = pollQuestion.replace(subRegex, '');
        } else {
            const kind = matches[1];
            const field = matches[2];
            pollQuestion = pollQuestion.replace(match[0], `[${kind}.${field}]`);
        }
    }

    return pollQuestion;
}

export function sanitizePollResponse (pollResponse, pollType) {
    if (!pollResponse || pollType !== 'PickList') {
        return pollResponse;
    }

    const deletionRegex = /{goto-((?!0)(\d+)|auto)\/}/g;
    pollResponse = pollResponse.replace(deletionRegex, '');

    return pollResponse;
}

export const EmptyGuideTemplate = {
    state: 'draft',
    launchMethod: 'auto',
    audienceUiHint: {
        filters: [],
    },
    editorType: EDITOR_TYPES.VDS,
    attributes: {
        type: 'building-block',
        device: { type: 'desktop' },
        overrideAutoThrottling: true,
        sharedServiceVersion: sharedServices.version,
    },
    steps: [],
};

export function cleanupPreviewedGuidesCSS () {
    const styleElements = document.querySelectorAll('style.pendo-style-undefined');

    styleElements.forEach((styleElement) => {
        styleElement.remove();
    });
}
